import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const trimbleConfig: TSPConfig = {
  key: 'trimble',
  name: 'Trimble',
  category: TSPCategory.CUSTOM,
  helpText:
    'Please request an username and password from your Trimble representative.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default trimbleConfig;
